import { render, staticRenderFns } from "./MantenedorTipoUbicacionPantalla.vue?vue&type=template&id=d663ec14&"
import script from "./MantenedorTipoUbicacionPantalla.vue?vue&type=script&lang=ts&"
export * from "./MantenedorTipoUbicacionPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d663ec14', component.options)
    } else {
      api.reload('d663ec14', component.options)
    }
    module.hot.accept("./MantenedorTipoUbicacionPantalla.vue?vue&type=template&id=d663ec14&", function () {
      api.rerender('d663ec14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MantenedorTipoUbicacion/MantenedorTipoUbicacionPantalla.vue"
export default component.exports